import React from "react";
import moment from "moment";
import { PayoutReadyRow } from "../../../../services/PartnerService";

/* 04/11/2026 (Quân): chip Payout ready ở Station Management. Luật ở backend services/partner/payoutReady.js. */
export const NHAN_PAYOUT: Record<string, { label: string; style: React.CSSProperties }> = {
	ready: { label: "Ready", style: { background: "#e8f5e9", color: "#1b5e20", border: "1px solid #a5d6a7" } },
	waiting_signature: {
		label: "Waiting signature",
		style: { background: "#fff8e1", color: "#b45309", border: "1px solid #ffe082" },
	},
	missing: { label: "Missing", style: { background: "#ffebee", color: "#b71c1c", border: "1px solid #ef9a9a" } },
	hq: { label: "HQ", style: { background: "#eceff1", color: "#37474f", border: "1px solid #cfd8dc" } },
};

export function chuThichPayout(r: PayoutReadyRow): string {
	const s = r.signature;
	const dong = [...r.reasons];
	if (r.level === "hq") dong.unshift("Chain account — takes no payouts");
	if (s?.signedAt) {
		dong.push(`Signed by ${s.signerName} on ${moment(s.signedAt).format("YYYY-MM-DD")} (${s.code})`);
		if (s.versions?.length) dong.push(s.versions.join(" · "));
	}
	return dong.join("\n");
}

export default function PayoutReadyCell(props: { row?: PayoutReadyRow }) {
	const r = props.row;
	if (!r) return <span style={{ color: "#9e9e9e", fontSize: "11px" }}>—</span>;
	const nhan = r.level ? NHAN_PAYOUT[r.level] : null;
	if (!nhan) return <span title={r.reasons.join("\n")} style={{ color: "#9e9e9e", fontSize: "11px" }}>—</span>;
	const hqDaKy = r.level === "hq" && r.signature?.state === "valid";
	return (
		<span
			title={chuThichPayout(r)}
			style={{
				display: "inline-block",
				padding: "2px 10px",
				borderRadius: "12px",
				fontSize: "11px",
				fontWeight: 600,
				whiteSpace: "nowrap",
				cursor: "help",
				...nhan.style,
			}}>
			{r.level === "hq" ? (hqDaKy ? "HQ · Signed" : "HQ · Not signed") : nhan.label}
		</span>
	);
}
